<mat-card appearance="outlined" style="padding: 16px;">
    <strong>Anrufe {{calls.length}}</strong>
    <div style="display: flex; flex-direction: column; margin-bottom: 20px;">
        <div style="display: flex;" *ngFor="let call of calls">
            <div style="margin-right: 5px;">
                <mat-icon *ngIf="call.isAnswered">call</mat-icon>
                <mat-icon *ngIf="!call.isAnswered">phone_missed</mat-icon>
            </div>
            <div style="margin-right: 5px;">
                <span *ngIf="call.incoming">Eingehend</span>
                <span *ngIf="call.outgoing">Ausgehend</span>
            </div>
            <div style="margin-right: 5px;">
                {{call.startAtUnix | date: 'dd.MM.yyyy - HH:mm'}}
            </div>
            <div style="margin-right: 5px;">bis {{call.endedAtUnix | date: 'dd.MM.yyyy - HH:mm'}}</div>
            <div>
                {{glo.getUserNameMitId(call.answeredBy)}}
            </div>
        </div>
    </div>

</mat-card>